import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import messages from "../../../../../assets/locale/messages";
import { UIActionModal } from "../../../../ui";
import { fillTemplate } from "../../../Form/Steps/ChooseCrewSize/crewSizeUtils";

import "../_CrewSizeUpgradeModals.scss";

/** Last confirmation before the upgrade request is raised to the Super Admin. */
const UpgradeSubmitConfirmModal = ({
  open,
  newCrewSizeName,
  submitting,
  onClose,
  onConfirm,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events, shared } = messages[lang];
  const t = events.viewEvents.crewSizeUpgrade.confirmModal;

  return (
    <UIActionModal
      open={open}
      variant="info"
      maxWidth="xs"
      className="crew-size-upgrade-modal"
      title={t.title}
      onClose={onClose}
      actions={
        <UIActionModal.Actions
          cancelLabel={shared.cancel}
          confirmLabel={events.creatEvent.publishPay.submitForApproval}
          confirmDisabled={submitting}
          onCancel={onClose}
          onConfirm={onConfirm}
        />
      }
    >
      <UIActionModal.Divider />
      <Typography component="p" className="text-body-sm crew-size-upgrade__message">
        {fillTemplate(t.message, { size: newCrewSizeName })}
      </Typography>
    </UIActionModal>
  );
};

UpgradeSubmitConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  newCrewSizeName: PropTypes.string.isRequired,
  /** The request is being sent: the confirm button is disabled. */
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

UpgradeSubmitConfirmModal.defaultProps = {
  submitting: false,
};

export default UpgradeSubmitConfirmModal;
